import { WalkthroughDefinition } from "./walkthrough-types";

/** Stable event names; renaming one splits its history in Product Analytics. */
export const WalkthroughEvent = {
  STARTED: "walkthrough/started",
  STEP_VIEWED: "walkthrough/step-viewed",
  COMPLETED: "walkthrough/completed",
  DISMISSED: "walkthrough/dismissed",
} as const;

export type WalkthroughEvent =
  (typeof WalkthroughEvent)[keyof typeof WalkthroughEvent];

interface WalkthroughEventProperties {
  walkthroughId: string;
  /** Zero-based among the tour's non-signal steps, intro modals included. A
   *  step the tour skips leaves a gap; use `completed` for completion. */
  stepPosition: number;
  stepCount: number;
  stepType?: "modal" | "highlight";
  /** Titles are translated, so the highlighted selector names the step. */
  stepTarget?: string;
}

export type WalkthroughEventHandler = (
  event: WalkthroughEvent,
  properties: WalkthroughEventProperties,
) => void;

export function walkthroughEventProperties(
  definition: WalkthroughDefinition,
  stepIndex: number,
): WalkthroughEventProperties {
  let stepPosition = 0;
  let stepCount = 0;
  for (const [i, step] of definition.steps.entries()) {
    if (step.type === "signal") {
      continue;
    }
    if (i < stepIndex) {
      stepPosition++;
    }
    stepCount++;
  }
  const step = definition.steps[stepIndex];
  return {
    walkthroughId: definition.id,
    stepPosition,
    stepCount,
    stepType: step && step.type !== "signal" ? step.type : undefined,
    stepTarget: step?.type === "highlight" ? step.targetSelector : undefined,
  };
}
